var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "permission-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.uuid != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        "aria-describedby": "nameFeedback"
                                      },
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("description"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.description,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "description", $$v)
                                        },
                                        expression: "item.description"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: { readonly: "" },
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.active,
                                            callback: function($$v) {
                                              _vm.$set(_vm.item, "active", $$v)
                                            },
                                            expression: "item.active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.uuid != null &&
                        _vm.$auth.check(_vm.model + ".update")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.uuid == null &&
                        _vm.$auth.check(_vm.model + ".create")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f09ba28c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f09ba28c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/permission/Form.vue
// module id = 1180
// module chunks = 0